import React from "react";
import { Link } from "react-router-dom";
import {
    expirationLabels,
    formatExpirationDate,
    getDaysUntilExpiration,
    getExpirationStatus,
} from "../utils/expiration";

export default function CredentialItem({ credential }) {
    var credentialStatus = credential["login-successful"]
        ? "success"
        : "failed";
    const expirationStatus = getExpirationStatus(credential.expires_at);
    const expirationLabel = expirationLabels[expirationStatus] || "Expiration";
    const formattedExpiration = formatExpirationDate(credential.expires_at);
    const daysRemaining = getDaysUntilExpiration(credential.expires_at);
    const expirationText =
        expirationStatus === "no-expiration"
            ? "No expiration"
            : formattedExpiration
              ? `Expires ${formattedExpiration}`
              : "Expiration date unavailable";
    const daysLabel =
        expirationStatus === "expiring-soon" && daysRemaining !== null
            ? `${daysRemaining} days left`
            : null;

    return (
        <Link
            to={`/credential/${credential.id}`}
            className="credential-link"
        >
            <div className="credential-item">
                <div className="credential-company">
                    <h2>{credential.company || "Untitled company"}</h2>
                </div>
                <div className="credential-desc">
                    <p className="credential-provider">{credential.provider || "No provider"}</p>
                    <div className="credential-expiration">
                        <span
                            className={`expiration-badge expiration-status ${expirationStatus}`}
                            aria-label={`Expiration status: ${expirationLabel}`}
                        >
                            {expirationLabel}
                        </span>
                        {expirationStatus !== "no-expiration" && <span className="expiration-date">
                            {expirationText}
                        </span>}
                        {daysLabel && (
                            <span className="expiration-days">
                                {daysLabel}
                            </span>
                        )}
                    </div>
                    <span className={`login-status ${credentialStatus}`}>
                        {credential["login-successful"] ? "Login confirmed" : "Login needs checking"}
                    </span>
                </div>
            </div>
        </Link>
    );
}
